<template>
    <div class="form-page text-center d-flex justify-content-center align-items-center">
        <main class="form-signin">
            <div class="w-100 d-flex justify-content-center mb-4 pb-4">
                <img
                    class="logo-img d-flex justify-content-center"
                    src="@/assets/logo-crop.png"
                    alt=""
                    srcset=""
                />
            </div>

            <div class="card card-medium-box reset-card" style="max-height: 450px">
                <div v-if="finished">
                    <h2 class="my-4">Email Sent</h2>

                    <p>
                        You will receive an email with instructions to reset your password. If you
                        do not receive it, please check your spam folder or retry later.
                    </p>

                    <div class="text-center">
                        <a href="javascript:;" @click="goTo('login')">Back to Login</a>
                    </div>
                </div>
                <div v-if="!finished">
                    <div class="right-container-box my-4">
                        <h2>Reset Password</h2>
                    </div>
                    <div
                        v-for="(error, index) in errors"
                        :key="index"
                        class="alert alert-danger"
                        role="alert"
                    >
                        {{ error }}
                    </div>
                    <form>
                        <div class="w-100 mt-2">
                            <input
                                type="email"
                                v-model="form.email"
                                placeholder="Your email address"
                                :disabled="loading || finished"
                                required
                                @keydown="clearField('email')"
                            />
                        </div>
                        <div class="buttons d-flex justify-content-between mt-4">
                            <button
                                @click="goTo('login')"
                                class="register-button"
                                :disabled="loading || finished"
                            >
                                Back to Login
                            </button>
                            <button
                                type="button"
                                @click="resetPassword()"
                                class="login-button d-inline-flex align-items-center justify-content-center gap-2"
                                :disabled="loading || finished"
                            >
                                <span
                                    v-if="loading"
                                    class="spinner-border spinner-border-sm spinner-color"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                {{ loading ? 'Sending email...' : 'Reset Password' }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import 'bootstrap/dist/css/bootstrap.min.css'
    import '@/assets/form-style.css'
    import { toast } from 'vue3-toastify'

    import { EMAIL_PASSWORD_RESET } from '@/data/url'

    export default {
        name: 'ForgotPassword',
        data() {
            return {
                backendURL: process.env.VUE_APP_BACKEND_URL,
                errors: [],
                form: {
                    email: '',
                },
                finished: false,
                loading: false,
            }
        },
        methods: {
            clearField(field) {
                const newErrors = this.errors.filter((item) => item != `The ${field} is required.`)
                this.errors = newErrors
            },
            goTo(destiny) {
                this.$router.push({ name: destiny })
            },
            async resetPassword() {
                if (this.loading || this.finished) {
                    return
                }

                this.errors = []

                if (!this.form.email) {
                    toast.error('The email is required.', {
                        position: 'top-right',
                        autoClose: 2000,
                    })
                    return
                }

                this.loading = true

                const url = this.backendURL + EMAIL_PASSWORD_RESET

                try {
                    const response = await fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            email: this.form.email,
                        }),
                    })

                    const data = await response.json()

                    if (data.error) {
                        this.errors.push(data.error || 'Login failed. Please try again.')
                    } else {
                        this.finished = data.status
                    }
                } catch (error) {
                    this.errors.push('Network error. Please try again.')
                } finally {
                    this.loading = false
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    .spinner-color {
        color: #e2a1a3;
    }
</style>
